module.exports = __webpack_public_path__ + "img/store-alt.11d57510.svg";